import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { environment } from './environments/environment'
import { CoreModule } from './app/core/core.module'

if (environment.production) {
  enableProdMode()
}

platformBrowserDynamic().bootstrapModule(CoreModule, {
  applicationProviders: [provideZoneChangeDetection()],
})
  .catch(err => console.error(err))
